import Text from '../../Text'

import { QA_NAME_CALENDAR_GRID_DAY_NUMBER } from './CalendarGridDayNumber.constants'

import * as styles from './CalendarGridDayNumber.module.css'

function CalendarGridDayNumber({
  children,
  className = styles.CalendarGridDayNumber,
  elementRef,
  ...restProps
}) {
  return (
    <Text
      {...restProps}
      className={className}
      qaName={QA_NAME_CALENDAR_GRID_DAY_NUMBER}
      ref={elementRef}
    >
      {children}
    </Text>
  )
}

export default CalendarGridDayNumber
